import { render, staticRenderFns } from "./BGImageButton.vue?vue&type=template&id=05ecfe62&scoped=true&"
import script from "./BGImageButton.vue?vue&type=script&lang=js&"
export * from "./BGImageButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ecfe62",
  null
  
)

export default component.exports